import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress "Script error." overlays in development — these come from the
// @emergentbase/visual-edits dev tool intercepting network requests, not from app code.
if (process.env.NODE_ENV === "development") {
    const _origOnError = window.onerror;
    window.onerror = function (message, source, lineno, colno, error) {
        if (!error || !error.message || message === "Script error.") return true;
        return _origOnError ? _origOnError(message, source, lineno, colno, error) : false;
    };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
